(function() {
  "use strict";
    
//   utility function  
  const Utils = {
    debounce(fn, delay) {
      let timer;
      return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }
  };

  
  const ProductReviewCarousel = {
    selector: ".mini-carousel-widget",

    init() {
      const carousel = document.querySelector(this.selector);

      if (!carousel) return; 

      const track = carousel.querySelector(".carousel-slider");
      const slides = track.querySelectorAll(".customer-review")
      const prevBtn = carousel.querySelector(".arrow-right");
      const nextBtn = carousel.querySelector(".arrow-left");
      const SLIDE_LENGTH = slides[0].clientWidth + 24;

      let currentIndex = 0;
      let dist = 0
      
      const updateCarousel = () => {
        
        track.style.transform = `translateX(-${dist}px)`;
      };

      if (nextBtn){
          nextBtn.addEventListener("click", () => {
            if (currentIndex === slides.length - 1) return; 
            if (currentIndex === slides.length - 2 ){
                nextBtn.classList.add('inactive-arrow')
            } 
            if (prevBtn.classList.contains('inactive-arrow')){
                prevBtn.classList.remove('inactive-arrow')
            }
            
            currentIndex += 1;
            dist += SLIDE_LENGTH
            updateCarousel();
          });
      }

      if (prevBtn){
          prevBtn.addEventListener("click", () => {
            if (currentIndex === 0) return;
            if (currentIndex === 1){
                prevBtn.classList.add("inactive-arrow")
            }
            if (nextBtn.classList.contains('inactive-arrow')){
                nextBtn.classList.remove('inactive-arrow')
            }
            currentIndex -= 1;
            dist = dist - SLIDE_LENGTH
            updateCarousel();
          });

      }


      
      updateCarousel();
      
    }
  };
  const AddLinkToJdgmWidget = {
    init() {

      this.addLink(document.querySelectorAll(".jdgm-prev-badge__text"));

      const observer = new MutationObserver(() => {
        const nodes = document.querySelectorAll(".jdgm-prev-badge__text");
        this.addLink(nodes);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    },

    addLink(nodeList) {
      nodeList.forEach(sp => {
        if (!sp.querySelector("a")) {
          const text = sp.textContent.trim();
          if (!text) return;

          sp.textContent = ""; 
          const link = document.createElement("a");
          link.href = "#m-app-section-template--17181049716799__175854093461026bd7"    // "/pages/customer-reviews";
          link.textContent = text;
          link.style.textDecoration = "underline"

          sp.appendChild(link);
        }
      });
    }
  };

  const ToggleKlarnaModal = {
    init() {
      const closeBtns = document.querySelectorAll(".kl-close-btn");
      const openModal = document.getElementById("kl-open-btn");
      const openModalHomePage = document.querySelector(".home-page-klarna");
      const klarnaModal = document.querySelector(".kl-modal__section");
      let openModalHomeBtn;
      
      if (openModalHomePage){
        openModalHomeBtn = openModalHomePage.querySelector('.m-button')
      }
      
      if (klarnaModal) {
        if (openModal){
          openModal.addEventListener('click', ()=> {
            klarnaModal.classList.remove("kl-toggle")
          })
        }
        if (openModalHomeBtn){
          
          openModalHomeBtn.addEventListener('click', (e)=>{
            e.preventDefault()
           
            klarnaModal.classList.remove("kl-toggle")
          })
          
        }
        closeBtns.forEach(btn => {
          btn.addEventListener('click', ()=>{
            klarnaModal.classList.add("kl-toggle")
          })
        })
      }
    }
  };
  const CustomCountdownTimer = {
    selector: ".custom-countdown-timer",

    init() {
      const timerEl = document.querySelector(this.selector);
      if (!timerEl) return;

      // Hardcoded deadline: Oct 1, 2025 12:00 AM EST (UTC-4)
      const deadline = new Date("2025-10-01T00:00:00-04:00").getTime();

      const daysEl = document.getElementById("days");
      const hoursEl = document.getElementById("hours");
      const minutesEl = document.getElementById("minutes");
      const secondsEl = document.getElementById("seconds");

      const updateCountdown = () => {
        const now = new Date().getTime();
        const distance = deadline - now;
        

        if (distance <= 0) {
          clearInterval(timer);
          timerEl.style.display = "none"
          return;
        } 

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = String(days).padStart(1, "0");
        hoursEl.textContent = String(hours).padStart(2, "0");
        minutesEl.textContent = String(minutes).padStart(2, "0");
        secondsEl.textContent = String(seconds).padStart(2, "0");
      };

      updateCountdown(); // run once immediately
      const timer = setInterval(updateCountdown, 1000);
    }
  };

  const ToggleDropDown = {
    
    init(){
        
      const btn = document.querySelector('.drop-down__btn');
      
      if (!btn) return;

      btn.addEventListener('click', (e)=> {
        
        const parentEl = e.currentTarget.closest('.product-dropdown__wrapper');
        if (!parentEl) return;
        const description = parentEl.querySelector('.dropdown__product-description');
        description.classList.toggle('close');
        btn.classList.toggle('rotate-btn')
      })
    }
  };
  const initAll = () => {
    ProductReviewCarousel.init();
    AddLinkToJdgmWidget.init();
    ToggleKlarnaModal.init();
    CustomCountdownTimer.init();
    ToggleDropDown.init();
    
  };

  
  document.addEventListener("DOMContentLoaded", initAll);

  
  document.addEventListener("shopify:section:load", initAll);

})();
